import styled from "styled-components";

export const InvisibleButton = styled.button`
  background: none;
  border: none;
  margin: 0;
  padding: 0;
`;
